import asyncForever from 'async/forever';
import DirStore from '../stores/dir_store';

import util from '../tools/util';

export default {
  fetch,
  hasMultiDownload,
};

export function hasMultiDownload() {
  return typeof (window as any).showDirectoryPicker === 'function';
}
export function fetch(params, done) {
  const { org_id, media_grant_id, media_list, dir_list, deleted_only } = params;

  const file_list = media_list.slice();
  const fetch_list = dir_list.map((dir) => params.path + dir.name);
  asyncForever(
    (done) => {
      const dir = fetch_list.pop();
      if (dir) {
        DirStore.fetch(
          { org_id, media_grant_id, path: dir },
          (err, results) => {
            if (err) {
              util.errorLog('DownloadHelper.fetch: err:', err);
            } else {
              results.media_list?.forEach?.((item) => {
                if (Boolean(deleted_only) === Boolean(item.is_deleted)) {
                  file_list.push(item);
                }
              });
              results.dir_list?.forEach?.((item) => {
                fetch_list.push(item.dir_name);
              });
            }
            done(err);
          }
        );
      } else {
        done('stop');
      }
    },
    (err) => {
      if (err === 'stop') {
        err = null;
      }
      done(err, file_list);
    }
  );
}
